import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider, keepPreviousData } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { MaintenanceGate } from './components/MaintenanceGate';
import './i18n';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // 🚀 لما الفلتر/البحث يتغير، نخلي البيانات القديمة معروضة حتى تطلع الجديدة
      // (يمنع القفزات الفارغة وتأثير "وميض" الواجهة)
      placeholderData: keepPreviousData,
    },
  },
});

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <MaintenanceGate>
        <RouterProvider router={router} />
      </MaintenanceGate>
    </QueryClientProvider>
  </StrictMode>,
);
